import { ChangeEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon, TextInput } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './RenameJourneyPopup.module.css';

type RenameJourneyPopupProps = {
  originalName: string;
  onRenameJourney: (name: string) => void;
  onCancel: () => void;
};

export const RenameJourneyPopup = ({
  originalName,
  onRenameJourney,
  onCancel,
}: RenameJourneyPopupProps) => {
  const { t } = useTranslation();

  const [name, setName] = useState(originalName);
  const onJourneyRenameChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setName(event.target.value);
    },
    [],
  );

  return (
    <BasicPopupContainer
      primaryButtonLabel={t('OK')}
      onPrimaryButtonClick={() => onRenameJourney(name)}
      onSecondaryButtonClick={onCancel}
    >
      <div className={styles.menu}>
        <div className={styles.titleRow}>
          <div className={styles.icon}>
            <SvgIcon
              name={SVGIconType.Rename}
              color="#333"
              width={24}
              height={24}
            />
          </div>
          <p className={styles.text}>{t('Rename')}</p>
        </div>
        <div className={styles.input}>
          <TextInput
            value={name}
            onChange={onJourneyRenameChange}
            placeholder={t('Journey Name')}
            style={{
              backgroundColor: '#f1f1f1',
              color: '#000',
            }}
            maxLength={50}
            showMaxLength={true}
            errorMessage={undefined} // FIXME: seems state from outside cannot passed in
          />
        </div>
      </div>
    </BasicPopupContainer>
  );
};
